import type { Guide, GuideRecordHint } from '../types';

/** S-21.10-07 — przekazanie obsadzonego zlecenia do Trade przez planistę do wyjazdu (scenariusz e2e 18, MIX-04). */
const ASSIGNED: GuideRecordHint = {
  description: 'zlecenie obsadzone Twoim pojazdem',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'FTL' },
};

export const guide: Guide = {
  flagKey: 'tradeTransferBeforeDeparture',
  title: 'Przekazanie obsadzonego zlecenia do Trade przez planistę do wyjazdu',
  whatItDoes:
    'Planista FTL przekazuje do Trade zlecenie obsadzone swoim pojazdem sam, dopóki pojazd nie wyruszył na załadunek — wyjazd szacujemy jak przy odpięciu (początek okna załadunku minus dolot). Powód wybiera się z listy, pojazd schodzi ze zlecenia i przy pracy dwutorowej zostaje wariantem. Po wyjeździe planista składa wniosek, który rozstrzyga Team Leader albo administrator.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-21.10-07'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'trade-transfer-self',
      title: 'Przed wyjazdem — przekazujesz sam',
      description:
        'Karta pokazuje szacowaną godzinę wyjazdu na załadunek. Do tej chwili „Przekaż do Trade” działa bez wniosku. Powód wybiera się z listy — gdy powód przekazania jest opcjonalny (osobna zmiana), przycisk działa także bez niego.',
      action: 'Wybierz powód przekazania z listy (albo zostaw bez powodu, gdy jest opcjonalny) i kliknij „Przekaż do Trade”.',
      recorder: { account: 'ftl2', demo: { kind: 'order', number: 'DEMO/2026/10/W01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'trade-transfer-request',
      title: 'Po wyjeździe — wniosek do przełożonego',
      description:
        'Gdy pojazd wyruszył na załadunek, zamiast przekazania jest „Wnioskuj o przekazanie do Trade” z powodem z listy i komentarzem. Pojazd zostaje przy zleceniu do decyzji.',
      action: 'Wybierz powód, dopisz komentarz i kliknij „Wnioskuj o przekazanie do Trade”.',
      recorder: { account: 'ftl2', demo: { kind: 'order', number: 'DEMO/2026/10/W03' } },
    },
    {
      route: '/ftl-team-leader-dashboard',
      target: 'ftl-tile-changeRequestsPending',
      title: 'Wnioski na pulpicie Team Leadera',
      description:
        'Team Leader widzi wnioski po wyjeździe na pulpicie; kafelek otwiera listę zleceń z tym samym filtrem, a decyzję — akceptację albo odrzucenie z powodem — podejmuje na karcie zlecenia.',
      action: 'Otwórz „Pulpit Team Leadera” i kliknij kafelek „Wnioski o zmianę pojazdu i przekazanie”.',
      recorder: { account: 'master' },
    },
  ],
};
